import { Link } from "react-router-dom";
import { Flower2, MapPin, Phone, Mail, ShieldCheck } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const s = useSettings();
  return (
    <footer className="relative border-t border-amber-500/15 bg-[#0F1117]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <Flower2 className="w-7 h-7 text-gold" strokeWidth={1.6} />
            <div className="font-syne font-extrabold text-lg gold-gradient-text">LOTUS LENTERA</div>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">{s.tagline || "Smart Technology for a Brighter Future"}</p>
          <div className="mt-4 inline-flex items-center gap-2 text-xs text-gold/80"><ShieldCheck className="w-4 h-4" /> Terpercaya & Bersertifikat</div>
        </div>
        <div>
          <h4 className="font-syne font-bold text-white mb-4">Layanan</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li>CCTV AI Security</li><li>Bot Automation</li><li>Digital Marketing</li><li>Maintenance IT</li><li>Solusi UMKM & Pemerintah</li>
          </ul>
        </div>
        <div>
          <h4 className="font-syne font-bold text-white mb-4">Navigasi</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/layanan" className="hover:text-gold">Layanan</Link></li>
            <li><Link to="/portofolio" className="hover:text-gold">Portofolio</Link></li>
            <li><Link to="/karir" className="hover:text-gold">Karir</Link></li>
            <li><Link to="/berita" className="hover:text-gold">Berita</Link></li>
            <li><Link to="/kontak" className="hover:text-gold">Kontak</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-syne font-bold text-white mb-4">Kontak</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex gap-2"><MapPin className="w-4 h-4 text-gold shrink-0 mt-0.5" /> {s.address || "Jakarta"}</li>
            <li className="flex gap-2"><Phone className="w-4 h-4 text-gold shrink-0" /> {s.phone || "+62 21 1234 5678"}</li>
            <li className="flex gap-2"><Mail className="w-4 h-4 text-gold shrink-0" /> {s.email || "info@lotuslentera.com"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} PT Lotus Lentera. All rights reserved. · <Link to="/admin" className="hover:text-gold" data-testid="footer-admin-link">Panel Admin</Link>
      </div>
    </footer>
  );
};
